import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../staff/StaffSideMenu";
import { useNavigate, useParams } from "react-router-dom";
import API_URL from "../../api/API";
import { useStaffAuthContext } from "../staff/useStaffAuthContext";

export const AdminCoachPaymentTransactions = () => {
  const { staff } = useStaffAuthContext();
  const { coach_id } = useParams();

  const [speedTransactions, setSpeedTransactions] = useState([]);
  const [strengthTransactions, setStrengthTransactions] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchPaymentTransactions = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_URL.GET_COACH_PURCHASE_DATA_ADMIN}${coach_id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${staff.token}`,
          },
        });

        const data = await response.json();

        if (response.ok) {
          setSpeedTransactions(data.speed || []);
          setStrengthTransactions(data.strength || []);
        } else {
          setError(data.error || "Failed to fetch payment transactions.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentTransactions();
  }, [coach_id, staff.token]);

  return (
    <div className="flex h-screen">
      <StaffSideMenu />
      <div className="flex-1 p-4 bg-gray-100 pt-16">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-xl font-semibold">Coach Payment Transactions</h1>
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            Go Back
          </button>
        </div>

        <div className="container mx-auto p-6">
          <h2 className="text-2xl font-bold mb-4">Purchase Transactions</h2>
          {error && <p className="text-red-500 mb-4">{error}</p>}
          {loading ? (
            <p>Loading transactions...</p>
          ) : speedTransactions.length === 0 && strengthTransactions.length === 0 ? (
            <p>No transactions available.</p>
          ) : (
            <div className="max-h-[500px] overflow-y-auto border border-gray-200 rounded-lg">
              {speedTransactions.length > 0 && (
                <>
                  <h3 className="text-lg font-semibold mt-4 mb-2">Speed Templates</h3>
                  <ul className="divide-y divide-gray-300">
                    {speedTransactions.map((transaction) => (
                      <li key={transaction._id} className="py-4 flex justify-between px-4">
                        <div>
                          <p className="text-sm font-semibold">
                            Template: {transaction.template_id}
                          </p>
                          <p className="text-gray-700">
                            Payment Status: {transaction.payment_status}
                          </p>
                          <p className="text-gray-700">Price: ${transaction.price}</p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </>
              )}
              {strengthTransactions.length > 0 && (
                <>
                  <h3 className="text-lg font-semibold mt-4 mb-2">Strength Templates</h3>
                  <ul className="divide-y divide-gray-300">
                    {strengthTransactions.map((transaction) => (
                      <li key={transaction._id} className="py-4 flex justify-between px-4">
                        <div>
                          <p className="text-sm font-semibold">
                            Template: {transaction.template_id}
                          </p>
                          <p className="text-gray-700">
                            Payment Status: {transaction.payment_status}
                          </p>
                          <p className="text-gray-700">Price: ${transaction.price}</p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
